export default __webpack_public_path__ + "static/media/tlpt.2d7ab19f.png";